import React from 'react'
import CompanySection from './CompanySection';
import TableMaterial from './TableMaterial';

export default function Information({dataB3, company, mutate}) {
    return (
        <div className='grid md:grid-cols-4 gap-3'>
            <CompanySection className="col-span-4 md:col-span-1" dataCompany={company} mutate={mutate}/>
            <TableMaterial className="col-span-4 md:col-span-3" dataB3={dataB3} mutate ={mutate}/>
        </div>
    )
}